import {
    AfterViewChecked,
    AfterViewInit,
    Component,
    ContentChildren,
    Input,
    OnDestroy,
    QueryList
} from '@angular/core';
import {AccordionTabComponent} from './accordion-tab.component';
import {LogicheckCaseService} from '../../services/logicheck-case.service';
import {CaseStateService} from '../../services/case-state.service';


@Component({
    selector: 'app-accordion',
    template: '<div class="panel-border"><ng-content></ng-content></div>',
    styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements AfterViewInit, OnDestroy, AfterViewChecked {

    @ContentChildren(AccordionTabComponent) accordionTabs: QueryList<AccordionTabComponent>;
    @Input() caseType: string;
    private subscriptions = [];
    private tabsCount: number;

    constructor(protected logicheckService: LogicheckCaseService, protected caseStateService: CaseStateService) {
    }


    ngAfterViewInit() {
        this.handleState();
        this.subscriptions.push(this.logicheckService.logicheckCase.subscribe(() => {
            this.accordionTabs.toArray().forEach(p => p.opened = false);
            return this.handleState();
        }));
    }

    openPanel(tabComponent: AccordionTabComponent) {
        // close all panels
        this.accordionTabs.toArray().forEach(p => p.opened = false);
        // open the selected panel
        if (tabComponent) {
            tabComponent.opened = true;
        }

    }

    isStateReached(tabNumber: number) {
        return this.getCurrentStateNumber() >= tabNumber;
    }

    getCurrentStateNumber(): number {
        if (this.logicheckService.currentCase) {
            if (this.logicheckService.viewState) {
                return this.caseStateService.getStateNo(this.logicheckService.viewState);
            }
            return this.caseStateService.getStateNo(this.logicheckService.currentCase.state);
        }
        return 0;
    }

    private handleState() {
        setTimeout(() => {
            const tabs = this.accordionTabs.toArray();
            if (tabs.length > 0) {
                // Open the first panel or panel with the correct state
                let index = this.caseType === undefined ? 0 : this.getCurrentStateNumber();
                if (index === -1) {
                    index = 0;
                }
                if (index === 0) {
                    let j = 0;
                    while (j < tabs.length) {
                        tabs[j].completed = false;
                        j++;
                    }
                } else {
                    let i = 0;
                    while (i < index && i < tabs.length) {
                        tabs[i].completed = true;
                        i++;
                    }
                }
                this.openPanel(this.accordionTabs.toArray()[index]);
            }
        });
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    ngAfterViewChecked(): void {
        if (!this.tabsCount || this.accordionTabs.toArray().length !== this.tabsCount) {
            this.tabsCount = this.accordionTabs.toArray().length;
            this.subscriptions = [];
            this.accordionTabs.toArray().forEach(p => p.opened = false);
            this.handleState();
            this.accordionTabs.toArray().forEach((tab: AccordionTabComponent) => {
                // subscribe panel toggle event
                this.subscriptions.push(tab.toggle.subscribe(() => {
                    const index = this.accordionTabs.toArray().indexOf(tab);
                    const open = this.caseType === undefined ||
                        this.isStateReached(index);
                    // Open the panel
                    if (open) {
                        this.openPanel(tab);
                    }
                }));
            });
        }
    }
}
